import styled from 'styled-components';


export const HowToBuyTrxContainer = styled.div`
    padding: 15px;
`